import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M6 17.59 7.41 19 12 14.42 16.59 19 18 17.59l-6-6z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m6 11 1.41 1.41L12 7.83l4.59 4.58L18 11l-6-6z"
}, "1")], 'KeyboardDoubleArrowUpOutlined');